import GridImage from './GridImage'

export default GridImage
